import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSidenavModule,
  MatSortModule,
  MatTableModule,
  MatToolbarModule,
  MatTooltipModule,
  MatListModule,
  MatSlideToggleModule
} from '@angular/material';
import {
  AvisosDialogModule,
  DualListModule,
  FilterModule,
  GridModule,
  MenuLateralModule,
  PaginationModule,
  RodapeModule,
  TelaErroModule,
  TipografiaModule,
  ToastModule,
} from 'govbr-lib';

import { AvatarModule } from 'ngx-avatar';
import { PipesModule } from '../pipes/pipes.module';
import { LoaderComponent } from './loader/loader.component';

// Módulo responsável por agregar todos os imports de módulos necessários e comuns à mais de um feature da aplicação.
// Uma vez importados aqui, fica mais simples a garantia de utilização dos componentes no seu projeto como um todo
// bastando apenas importar o shared module no seu feature module
// IMPORTANTE: toda vez que um módulo precisar ser importado com .forRoot(), o mesmo deve ser importado no core module.
// módulos que precisam de .forChild deve ser declarados no feature module
// Todos os injection tokens também devem ser declarados no core module, pois precisam ser carregados
// no inicio da aplicação

@NgModule({
  imports: [
    CommonModule,
    TelaErroModule,
    AvatarModule,
    RodapeModule,
    GridModule,
    MenuLateralModule,
    MatInputModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatSelectModule,
    MatDialogModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatTooltipModule,
    AvisosDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDividerModule,
    PaginationModule,
    TipografiaModule,
    RodapeModule,
    FilterModule,
    PipesModule,
    MatProgressBarModule,
    MatDatepickerModule,
    DualListModule,
    MatListModule,
    ToastModule,
    MatSlideToggleModule,
  ],
  exports: [
    CommonModule,
    TelaErroModule,
    AvatarModule,
    RodapeModule,
    GridModule,
    MenuLateralModule,
    MatExpansionModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogModule,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatTooltipModule,
    AvisosDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDividerModule,
    PaginationModule,
    TipografiaModule,
    RodapeModule,
    FilterModule,
    PipesModule,
    MatProgressBarModule,
    MatDatepickerModule,
    DualListModule,
    MatListModule,
    ToastModule,
    MatSlideToggleModule,
    LoaderComponent
  ],
  declarations: [LoaderComponent],
})

export class SharedModule { }
